export default function GravityFormsTracking() {
    const params = new URLSearchParams(window.location.search);
    const event = params.get('gf_submitted');

    if (!event) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event,
    });

    params.delete('gf_submitted');
    const query = params.toString();
    const cleanUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    window.history.replaceState({}, '', cleanUrl);
};
